// Module
var code = "<div class=vp-modal><div class=vp-space-header><div class=vp-space-title><h2>{{venue.data.name}} </h2></div></div><div class=vp-menu-description-modal><p class=user-formatting>{{venue.admin.adminDescription}}</p></div></div>";
// Exports
module.exports = code;